<template>
  <div
    @mouseenter="hoverHandler()"
    @click="clickHandler"
    @mouseleave="outHandler()"
    :style="{background: isHover || is_choose ? '#F2F2F2' : ''}"
    class="step-item-main"
  >
    <div class="item-left">
      <div class="item-left-line"></div>
      <div :class="['item-left-circle', item.channel == 0 ? 'item-left-circle-red' : 'item-left-circle-blue']"></div>
    </div>
    <div class="item-content" v-if="!isEditor">
      <div class="content-title">
        <div :class="{'text-red': item.channel == 0}">&nbsp;&nbsp;{{ item.name }}</div>
        <div v-show="isHover && item.channel != 0">
          <img
            @click="editOrganization"
            class="use-card-img"
            style="margin-right:12px;"
            src="../../assets/edit.png"
          >
          <img @click="stopOrganizationConfirm" class="use-card-img" src="../../assets/stoping.png">
        </div>
      </div>
      <div class="content-date" v-if="item.channel != 0">&nbsp;&nbsp;有效期：{{item.validityPeriod}}</div>
    </div>
    <!-- editing -->
    <div class="item-content" v-if="isEditor">
      <div class="content-title">
        <div>
          <el-input v-model="form.name" size="mini" style="width:175px;" placeholder="组织名称"></el-input>
        </div>
        <div>
          <el-button :disabled="!save_button_state" @click="edit" plain size="mini">保存</el-button>
          <el-button @click="cancel" plain size="mini" style="margin-left: 5px">取消</el-button>
        </div>
      </div>
      <div class="content-date">
        <el-date-picker
          style="width:175px;"
          v-model="form.validityPeriod"
          type="date"
          size="mini"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
    </div>
  </div>
</template>
<script>
import Store from '@/store'
import { editAssociation, allOnAssociation, allOffAssociation, disableAssociation } from '@/api/'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      form: {
        name: this.item.name,
        validityPeriod: this.item.validityPeriod
      },
      isHover: false,
      isEditor: false
    }
  },
  props: {
    organization_id: {
      type: Number,
      default: -1
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      current_association: 'current_association',
      search: 'search'
    }),
    save_button_state () {
      return !!this.form.name && !!this.form.validityPeriod
    },
    is_choose () {
      return this.current_association.id === this.item.id
    }
  },
  methods: {
    hoverHandler () {
      this.isHover = true
    },
    outHandler () {
      this.isHover = false
    },
    editOrganization () {
      this.isEditor = true
    },
    stopOrganizationConfirm () {
      this.$confirm(`确定停用组织  ${this.current_association.name} ？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      })
        .then(() => {
          this.stopOrganization(this.current_association.id)
        })
        .catch(() => {})
    },
    async stopOrganization (id) {
      let res = await disableAssociation(this, id)
      if (res && Number.parseInt(res.ret) === 1) {
        this.$message.success('停用成功')
        allOnAssociation(this, this.search)
        allOffAssociation(this, this.search)
        Store.store('users_in_current_channel', [])
        this.isEditor = false
      } else {
        this.$message.error(res.msg)
      }
    },
    clickHandler () {
      // 组织被点击后
      this.$emit('on-click', this.item)
    },
    cancel () {
      this.isEditor = false
    },
    async edit () {
      try {
        const res = await editAssociation(this, this.item.id, this.form)
        if (res && Number.parseInt(res.ret) === 1) {
          this.$message({
            message: '恭喜你，这是一条成功消息',
            type: 'success'
          })
          allOnAssociation(this, this.search)
          this.isEditor = false
        } else {
          this.$message.error('错了哦，这是一条错误消息')
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style scoped>
.step-item-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 42px;
  /* background: #F2F2F2; */
}
.item-left {
  width: 40px;
  display: flex;
  justify-content:flex-end;
  position: relative;
  /* border-right: 3px solid #bce4f5; */
  /* border-bottom: 1px solid #ffffff; */
}
.item-left-line {
  height: 100%;
  border-left: 1px solid #2d8cf0;
  position: absolute;
  left: calc(50%-1px);
  top: 0;
  right:5px;
}
.item-left-circle {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 1px solid transparent;
  position: absolute;
  top:11px;
}
.item-left-circle-blue {
  background-color: #2d8cf0;
  border-color: #2d8cf0;
  color: #2d8cf0;
}
.item-left-circle-red {
  background-color: #bb2935;
  border-color: #bb2935;
  color: #bb2935;
}
.text-red {
  color: #bb2935;
}
.item-content {
  flex-basis: 100%;
  /* border-bottom: 1px solid #ffffff; */
  display: flex;
  flex-direction: column;
}
.content-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8px;
  height: 33px;
}
.content-date {
  margin-top: 4px;
  margin-bottom: 8px;
}
.use-card-img {
  width: 20px;
  height: 20px;
}
</style>
